import { Injectable } from "@angular/core";

@Injectable()
export class ConfigService {
  //Variable conexion con Laravel
  //PATH: any = 'http://localhost:8007'; //TESTING
  //PATH: any = 'http://localhost:8008'; //LIBERADO
  // PATH: any = 'http://prosof.co:8013/woms/back_prosof/public'; //Prosof
  //PATH: any = 'http://prosof.co:8013/woms/back_demo/public'; //Demo
  //PATH: any = 'http://192.168.0.236:8013/woms/back_demo/public'; //Demo

  PATH: any = "http://prosof.co:8013/CocoraSM/BackCocoraSM/public"; //PRODUCCION
  //PATH: any = "http://cs.prosof.co:8013/CocoraSM/BackCocoraSM/public"; //WOMS PRODUCCION CS

  //PATH: any = "https://cocorasm.clubcampestre.com.co/BackCocoraSM/public"; //WOMS Medellin
  //PATH: any = "http://192.168.1.20:8013/CocoraSM/BackCocoraSM/public"; //WOMS Medellin Local

  //PATHFROM: any = 'http://localhost:4204/index.html#';
  //PATHFROM: any = 'http://192.168.0.224:8017/Testing/CocoraSM/index.html#'; //TESTING
  //ATHFROM: any = 'http://192.168.0.224:8017/liberado/CocoraSM/index.html#'; //LIBERADO
  //PATHFROM: any = 'http://192.168.0.224:8017/Testing/CocoraSM_Martha/index.html#'; //TESTING MARTHA
  PATHFROM: any = "http://prosof.co:8013/CocoraSM/index.html#"; //COCORASM PRODUCCION
  //PATHFROM: any = "http://cs.prosof.co:8013/CocoraSM/index.html#"; //COCORASM PRODUCCION CS
  //PATHFROM: any = "http://192.168.1.20:8013/CocoraSM/index.html#"; //Medellin
  //PATHFROM: any = "http://192.168.1.20:8013/LCocoraSM/index.html#"; //Medellin Local
  //PATHFROM: any = "https://cocorasm.clubcampestre.com.co/index.html#"; //Medellin

  //Arreglo para los accesos de super administrador Prosof
  ACCESOS_PRO = [
    { usuario: "prosof" },
    { clave: "SRVC" },
    // {clave: 'csprsf'}
  ];

  constructor() {}

  /**
   * Permite obtener la ruta para la conexión con Laravel
   * JMM-2018-03-20
   */
  obtenerPath() {
    // document.oncontextmenu = function () {return false};
    return this.PATH;
  } //Fin de obtenerPath()

  /**
   * Permite obtener la ruta para la conexiónangular
   * utilizado para almacenar ruta angular y manejarlo en dashboard y los informes
   * CESAR ARIAS-2020-03-10
   */
  obtenerPathAngular() {
    return this.PATHFROM;
  } //Fin de obtenerPathAngular()

  /**
   * Permite gestionar las claves de acceso de super admin en la aplicación
   * JMM-2018-04-13
   */
  accesosPro() {
    return this.ACCESOS_PRO;
  } //Fin de accesosPro()

  /**
   * Mensaje cuando el texto excede el tamaño permitido
   * PABLO GONZALEZ 11/05/2018
   */
  errorMaxLength() {
    return "Se excede el tamaño permitido";
  }

  /**
   * Mensaje cuando el formato del texto es erroneo
   * PABLO GONZALEZ 11/05/2018
   */
  errorPattern() {
    return "El formato es incorrecto no puede tener espacios ni letras";
  }

  /**
   * Mensaje cuando el formato del texto es erroneo
   * PABLO GONZALEZ 11/05/2018
   */
  errorRequired() {
    return "El campo es requerido";
  }

  /**
   * Mensaje de error para validar decimales
   * JMM-2018-09-27
   */
  errorPatternNumerosDecimales() {
    return "Formato incorrecto. Nota: Si es decimal, solo se permiten máximo 7 decimales después del punto.";
  }

  /**
   * Mensaje cuando el formato del texto es erroneo con numeros con decimales despues de una coma
   * JMM-2019-06-17
   */
  errorPatternDecimalConComa() {
    return "El formato es incorrecto no puede tener espacios, ni letras, ni puntos, solo se permite la coma para los decimales.";
  }

  /**
   * Mensaje cuando el formato del texto es erroneo solo para nuemros enteros positivos
   * JMM-2019-06-17
   */
  errorPatternSoloEnterosPositivos() {
    return "El formato es incorrecto no puede tener espacios, ni letras, ni puntos, solo se permite la coma para los decimales.";
  }
}



// WEBPACK FOOTER //
// E:/xampp/htdocs/liberado/CocoraSMFront/src/app/servicios/config/config.service.ts